import { render, staticRenderFns } from "./FileProcess.vue?vue&type=template&id=c369486c"
import script from "./FileProcess.vue?vue&type=script&lang=js"
export * from "./FileProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports